/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCallFeedbacks200Response } from '../models';
/**
 * CallFeedbackApi - axios parameter creator
 * @export
 */
export const CallFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * コールFB一覧取得API
         * @summary コールFB一覧取得API
         * @param {number} [page] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [userId] 
         * @param {string} [connectedTo] 
         * @param {number} [callResultTypeId] 
         * @param {number} [defaultCallResultTypeId] 
         * @param {number} [callResultId] 
         * @param {boolean} [unconfirmed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallFeedbacks: async (page?: number, startDate?: string, endDate?: string, userId?: number, connectedTo?: string, callResultTypeId?: number, defaultCallResultTypeId?: number, callResultId?: number, unconfirmed?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_feedbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (connectedTo !== undefined) {
                localVarQueryParameter['connected_to'] = connectedTo;
            }

            if (callResultTypeId !== undefined) {
                localVarQueryParameter['call_result_type_id'] = callResultTypeId;
            }

            if (defaultCallResultTypeId !== undefined) {
                localVarQueryParameter['default_call_result_type_id'] = defaultCallResultTypeId;
            }

            if (callResultId !== undefined) {
                localVarQueryParameter['call_result_id'] = callResultId;
            }

            if (unconfirmed !== undefined) {
                localVarQueryParameter['unconfirmed'] = unconfirmed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallFeedbackApi - functional programming interface
 * @export
 */
export const CallFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * コールFB一覧取得API
         * @summary コールFB一覧取得API
         * @param {number} [page] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [userId] 
         * @param {string} [connectedTo] 
         * @param {number} [callResultTypeId] 
         * @param {number} [defaultCallResultTypeId] 
         * @param {number} [callResultId] 
         * @param {boolean} [unconfirmed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallFeedbacks(page?: number, startDate?: string, endDate?: string, userId?: number, connectedTo?: string, callResultTypeId?: number, defaultCallResultTypeId?: number, callResultId?: number, unconfirmed?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallFeedbacks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallFeedbacks(page, startDate, endDate, userId, connectedTo, callResultTypeId, defaultCallResultTypeId, callResultId, unconfirmed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallFeedbackApi - factory interface
 * @export
 */
export const CallFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallFeedbackApiFp(configuration)
    return {
        /**
         * コールFB一覧取得API
         * @summary コールFB一覧取得API
         * @param {number} [page] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [userId] 
         * @param {string} [connectedTo] 
         * @param {number} [callResultTypeId] 
         * @param {number} [defaultCallResultTypeId] 
         * @param {number} [callResultId] 
         * @param {boolean} [unconfirmed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallFeedbacks(page?: number, startDate?: string, endDate?: string, userId?: number, connectedTo?: string, callResultTypeId?: number, defaultCallResultTypeId?: number, callResultId?: number, unconfirmed?: boolean, options?: any): AxiosPromise<GetCallFeedbacks200Response> {
            return localVarFp.getCallFeedbacks(page, startDate, endDate, userId, connectedTo, callResultTypeId, defaultCallResultTypeId, callResultId, unconfirmed, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallFeedbackApi - interface
 * @export
 * @interface CallFeedbackApi
 */
export interface CallFeedbackApiInterface {
    /**
     * コールFB一覧取得API
     * @summary コールFB一覧取得API
     * @param {number} [page] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [userId] 
     * @param {string} [connectedTo] 
     * @param {number} [callResultTypeId] 
     * @param {number} [defaultCallResultTypeId] 
     * @param {number} [callResultId] 
     * @param {boolean} [unconfirmed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackApiInterface
     */
    getCallFeedbacks(page?: number, startDate?: string, endDate?: string, userId?: number, connectedTo?: string, callResultTypeId?: number, defaultCallResultTypeId?: number, callResultId?: number, unconfirmed?: boolean, options?: AxiosRequestConfig): AxiosPromise<GetCallFeedbacks200Response>;

}

/**
 * Request parameters for getCallFeedbacks operation in CallFeedbackApi.
 * @export
 * @interface CallFeedbackApiGetCallFeedbacksRequest
 */
export interface CallFeedbackApiGetCallFeedbacksRequest {
    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly endDate?: string

    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly userId?: number

    /**
     * 
     * @type {string}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly connectedTo?: string

    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly callResultTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly defaultCallResultTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly callResultId?: number

    /**
     * 
     * @type {boolean}
     * @memberof CallFeedbackApiGetCallFeedbacks
     */
    readonly unconfirmed?: boolean
}

/**
 * CallFeedbackApi - object-oriented interface
 * @export
 * @class CallFeedbackApi
 * @extends {BaseAPI}
 */
export class CallFeedbackApi extends BaseAPI implements CallFeedbackApiInterface {
    /**
     * コールFB一覧取得API
     * @summary コールFB一覧取得API
     * @param {CallFeedbackApiGetCallFeedbacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackApi
     */
    public getCallFeedbacks(requestParameters: CallFeedbackApiGetCallFeedbacksRequest = {}, options?: AxiosRequestConfig) {
        return CallFeedbackApiFp(this.configuration).getCallFeedbacks(requestParameters.page, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, requestParameters.connectedTo, requestParameters.callResultTypeId, requestParameters.defaultCallResultTypeId, requestParameters.callResultId, requestParameters.unconfirmed, options).then((request) => request(this.axios, this.basePath));
    }
}
